module.exports = __webpack_public_path__ + "img/foxium.b3af0bc9.svg";